import { SalesPipelineContactStatus } from '@shared/enums';

export const salesPipelineContactStatusDisplayName = ({
  status,
}: {
  status: SalesPipelineContactStatus;
}) => {
  switch (status) {
    case 'new':
      return 'New';
    case 'awaiting_response':
      return 'Inactive';
    case 'active_conversation':
      return 'Active';
    case 'drafting':
      return 'Draft';
    case 'contract_sent':
      return 'Sent';
    case 'payment_pending':
      return 'Signed';
    case 'deposit_received':
      return 'Paid';
    case 'disqualified':
      return 'Disqualified';
    case 'no_answer':
      return 'No Answer';
    default:
      return status;
  }
};
